import { enrichPointsWithIdByType } from './points';
import { mapCtnListToPhoneNumbersList } from './ctn';
import { enrichIntervalsWithVersion } from './routes';
import { getMinimalCreditPayment } from './payment';
import { collapseCartDuplicates } from './order';

type WithRequiredKeys<T, K extends keyof T> = Required<Pick<T, K>> & T;

export class Mapper<MapperData = any> {
  data: MapperData | undefined;

  constructor(data?: MapperData) {
    this.data = data;
  }

  enrichIntervalsWithVersion = enrichIntervalsWithVersion;

  enrichPointsWithIdByType = enrichPointsWithIdByType;

  mapCtnListToPhoneNumbersList = mapCtnListToPhoneNumbersList;

  getMinimalCreditPayment = getMinimalCreditPayment;

  collapseCartDuplicates = collapseCartDuplicates;

  /**
   * Универсальные хелперы для простого маппинга
   */

  /**
   * Берёт поле из объекта
   */
  pick =
    <T extends Record<string, any>, K extends keyof T>(key: K) =>
    (response: T) =>
      response[key];

  /**
   * Фильтрует массив проверяя существование поля
   */
  filterBy =
    <T extends Record<string, any>, K extends readonly (keyof T)[]>(
      keys: K,
    ): ((response: T[]) => Array<WithRequiredKeys<T, K[number]>>) =>
    (response) =>
      response.filter((item): item is WithRequiredKeys<T, K[number]> =>
        keys.every((key) => item[key] != null),
      );
}
